import React, { useEffect, useState } from 'react';

import './AcquisitionsLoader.css';

export interface IAcquisitionsLoaderProps {
    processingSteps: string[];
    isZoomedIn?: boolean;
}

export const AcquisitionsLoader = (props: IAcquisitionsLoaderProps) => {
    const [currentStep, setCurrentStep] = useState<string>('');
    const [processingSteps, setProcessingSteps] = useState<string[]>([]);
    const [initialStep, setInitialStep] = useState<boolean>(true);

    useEffect(() => {
        if (initialStep && props.processingSteps.length > 0) {
            const steps = [...props.processingSteps];
            setCurrentStep(steps.shift() as string);
            setProcessingSteps(steps);
            setInitialStep(false);
        }
        if (!initialStep && processingSteps.length > 0) {
            setTimeout(() => {
                const steps = processingSteps;
                setCurrentStep(steps.shift() as string);
                setProcessingSteps(steps);
            }, 2000);
        }
    }, [initialStep, processingSteps, currentStep]);

    return (
        <div className='AcquisitionsLoader__wrapper'>
            <div className={`AcquisitionsLoader__content ${props.isZoomedIn ? 'AcquisitionsLoader__content--zoomed' : ''}`}>
                <h2 className='AcquisitionsLoader__header'>Your request is being processed.</h2>
                <div className='AcquisitionsLoader__processingText'>{currentStep}</div>
                <p>
                    <svg className='AcquisitionsLoader__spinner' aria-hidden='true'
                        data-icon='spinner' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
                        <path fill='currentColor'
                            d='M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z'></path>
                    </svg>
                </p>
                <h3 className='AcquisitionsLoader__subHead'>Please wait.</h3>
            </div>
        </div>

    );
};